import { hashData } from "./calculateFileHash";

const calculateStringHash = async (String, checksum) => {
  //Convert string to buffer
  const encoder = new TextEncoder();
  const buffer = encoder.encode(String);

  return await hashData(buffer, checksum);
};

export default calculateStringHash;
